export const HAS = 'HAS'
export const HAS_TYPE = 'HAS_TYPE'
export const GET = 'GET'
export type GetFlag = (payload: { type: string, name: string }) => boolean | undefined
export type HasType = (payload: { type: string }) => boolean
